module.exports = __webpack_public_path__ + "img/ma.408c0351.png";